import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

const InputField = (props) => {
  return (
    <>
      <Row className="mt-2">
        <Col md={props.firstMd || 3}>
          <label>{props.label}</label>
        </Col>
        <Col md={props.secondMd || 9}>
          <Form.Control
            size="sm"
            className="fw-bold"
            readOnly
            value={props.value}
          />
        </Col>
      </Row>
    </>
  );
};

export default InputField;
